import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles({
    root: {
        padding: '10px 10px 0 10px',
        width: '100%'
    },
    chips: {
        width: '100%',
        margin: '0 5px',
        marginBottom: -1
    },
    btn: {
        borderRadius: 2,
        border: '1px solid #3f51b4',
        color: '#3f51b4',
        padding: '3px 10px',
        cursor: 'pointer',
        fontSize: '0.8rem',
        display: 'inline-block',
    },
    btnActive: {
        borderRadius: 2,
        backgroundColor: '#3f51b4',
        color: '#fff',
    },
    priceRangeSlider: {
        width: 'calc(100% - 29px)',
        marginLeft: 13,
    },
    priceRangeValue: {
        minWidth: 50,
    },
    block: {
        borderBottom: '1px solid #ccc',
        minHeight: 50,
        position: 'relative'
    },
    blockHeader: {
        padding: '14px 10px 5px 20px',
        cursor: 'pointer'
    },
    expand: {
        marginRight: 5,
        cursor: 'pointer'
    },
    clear: {
        marginLeft: 10,
    },
    priceCont: {
        margin: '0 20px 20px 20px'
    },
});

export default function PriceDesktop(props) {

    const [open, setOpen] = React.useState(false);

    const classes = useStyles();

    const filter = props.filter;

    const params = props.filter.params;

    const CustomSlider = props.customSlider;

    const CustomThumbComponent = props.customThumbComponent;

    const handleOpenClick = (e) => {
        e.preventDefault();
        setOpen(!open);
    };

    const handleClearClick = (e) => {
        e.preventDefault();
        filter.dispatchResetPriceRange();
    };

    props.initPriceRange();

    if(isNaN(params.priceRangeValue[0]) || isNaN(params.priceRangeValue[1])) {
        return;
    }

    return (
        <div className={classes.block}>
            <div className={props.classes.opener} onClick={handleOpenClick}>
                {open ? <RemoveIcon/> : <AddIcon/>}
            </div>
            <div className={classes.blockHeader} onClick={handleOpenClick}><Typography><b>Price</b></Typography></div>
            {open ?
                <div className={classes.priceCont}>
                    <Typography id="range-slider" gutterBottom>
                        ${(new Intl.NumberFormat().format(1000*Math.floor(params.priceRangeValue[0]/(100*1000))))}
                                {"—"+props.getRangeUpperLabel()}
                    </Typography>

                    <div className={classes.priceRangeSlider}>
                        <CustomSlider
                            ThumbComponent={CustomThumbComponent}
                            value={params.priceRangeValue}
                            onChange={props.handlePriceRangeChange}
                            onChangeCommitted={props.handleSubmit}
                            aria-labelledby="range-slider"
                            min={params.priceRangeMin}
                            max={Math.min(params.priceRangeMax, params.priceRangeLimitMax)}
                        />
                    </div>
                </div> : null}
        </div>
    )
}